import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { Id } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

export type ApiRequest_GetUnreadInboxCount = {
  location_id?: Id;
};

export type ApiResponse_GetUnreadInboxCount = {
  unreadCount: number;
};

const ENDPOINT = 'conversation/inbox/unread-count';
const METHOD = 'GET';

export const QUERY_KEY = (params: ApiRequest_GetUnreadInboxCount) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useGetUnreadInboxCount = (params: ApiRequest_GetUnreadInboxCount, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: !!params.location_id && enabled && !!session?.access_token,
    queryKey: QUERY_KEY(params),
    queryFn: async (): Promise<ApiResponse_GetUnreadInboxCount> =>
      handleApiCall<ApiResponse_GetUnreadInboxCount, ApiRequest_GetUnreadInboxCount>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {}),
        params
      ),
    refetchInterval: 30000, // Refetch every 30 seconds for real-time updates
    staleTime: 0, // Always consider data stale to ensure fresh counts
  });
};
